
import { Heading } from "@utilitywarehouse/hearth-react";

const PageHeader: React.FC = () => {
  return <Heading size="xl">UW cares</Heading>;
};

export default PageHeader;
